module.exports = __webpack_public_path__ + "static/media/Italy-sunset.d8bc6789.svg";